<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> Configuração de Mensagens de Ausência </h3>
        <small>Configuração das mensagens de ausência.</small>
      </div>
    </div>

    <Tables ref="tableGrid"
            :columns="['Tempo de Ausência', 'Mensagem', 'Finaliza Conversa', 'Ações']"
            :showNew="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Edit="onEdit"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.horasAusente ? (obj.horasAusente.toString() + ' Hora(s)') : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagem ? obj.mensagem : ''" />
        <TableColumn :IsCustom="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1">
          <span class="badge badge-pill badge-success" v-if="obj.finalizaConversa === true">Sim</span>
          <span class="badge badge-pill badge-secondary" v-else>Não</span>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

    <AddModal ref="addModal" @Reload="onLoadAll" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AddModal from './components/addModal.vue'
import MensagemAusenteRepository from '@/shared/http/repositories/configurations/mensagemausente.js'

export default {
  name: 'MensagensAusencia',
  mixins: [ActionsForm],
  components: {
    AddModal
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      MensagemAusenteRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    onNew () {
      this.$refs.addModal.onAdd()
    },
    onEdit (obj) {
      this.$refs.addModal.onEdit(obj.id)
    },
    onDelete (obj) {
      loading.push()
      MensagemAusenteRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success('Mensagem de ausência excluída com sucesso!')
          this.onLoadAll()
        })
        .catch((error) => {
          loading.pop()
          toast.error('Erro ao excluir mensagem de ausência: ' + error.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensAusencia/mensagensAusencia.vue